import InputField from 'components/fields/InputField';

const EditTestModal = ({
  editingTest,
  setEditingTest,
  handleSaveUpdate,
  onCancel,
}) => {
  return (
    <div className="bg-black fixed inset-0 z-10 flex items-center justify-center bg-opacity-50">
      <div className="relative mx-4 w-full max-w-md rounded-lg bg-white p-4 text-brand-900 shadow-lg dark:bg-navy-700 md:mx-0 md:p-8">
        <button
          type="button"
          onClick={onCancel}
          className="absolute right-2 top-2 h-10 w-8 rounded-full text-3xl text-brand-900 transition duration-200 dark:text-white/60"
        >
          &times;
        </button>

        <h2 className="mb-4 text-lg font-medium text-navy-800 dark:text-navy-200">
          Edit Test Link
        </h2>

        <form>
          <div className="mb-4">
            <InputField
              label="Test Date"
              type="date"
              value={editingTest?.testDate || ''}
              onChange={(e) =>
                setEditingTest({
                  ...editingTest,
                  testDate: e.target.value,
                })
              }
              className="block w-full rounded-md border-none border-gray-300 shadow-sm outline-none sm:text-sm"
            />
          </div>

          <div className="mb-4">
            <InputField
              label="Test Time"
              type="time"
              value={editingTest?.testTime || ''}
              onChange={(e) =>
                setEditingTest({
                  ...editingTest,
                  testTime: e.target.value,
                })
              }
              className="mt-1 block w-full rounded-md border-none border-gray-300 shadow-sm outline-none sm:text-sm"
            />
          </div>

          <div className="mb-4">
            <InputField
              label="Test Link"
              type="text"
              value={editingTest?.testLink || ''}
              onChange={(e) =>
                setEditingTest({
                  ...editingTest,
                  testLink: e.target.value,
                })
              }
              className="mt-1 block w-full rounded-md border-none border-gray-300 shadow-sm outline-none sm:text-sm"
            />
          </div>

          <div className="flex justify-end space-x-3">
            <button
              type="button"
              onClick={onCancel}
              className="rounded-xl bg-lightPrimary px-4 py-3 text-base font-medium text-navy-700 transition duration-200 dark:bg-white/5 dark:text-white dark:hover:bg-white/10 dark:active:bg-white/20"
            >
              Cancel
            </button>
            <button
              type="button"
              onClick={handleSaveUpdate}
              className="rounded-xl bg-brand-500 px-4 py-3 text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200"
            >
              Save
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditTestModal;
